import { Link, useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { addRoomApi, deleteRoomApi, editRoomApi, getAllRoomApi } from "../../api/room";

function RoomDetails(){
    const { id } = useParams(); 
    const [data, setData] = useState({name:""});
    const [pop, setPop] = useState("");
    const [selected, setSelected] = useState("");
    const [allRoom, setAllRoom] = useState([]);


    function set(e){

        setData({
            ...data,
            [e.target.name]:e.target.value
        })
    }

    useEffect(()=>{
        getAllRoomApi(id).then((res)=>{
                
            if(res.status == "success"){
                setAllRoom(res?.data?.rooms);
            }
        })
    },[])


    function submitAdd(){
        if(data.name == ""){
            toast.error("Please enter floor name");
        }else{

            addRoomApi({...data, floor_id:id}).then((res)=>{
                if(res.status == "success"){
                    toast.success("Floor added successfully");
                    getAllRoomApi(id).then((res)=>{
                
                        if(res.status == "success"){
                            
                            setAllRoom(res?.data?.rooms);
                        }
                    })

                    setPop("");
                    setData({name:""});
                    setSelected("");
                }else{
                    toast.error("Failed to add floor");
                }
            })
        }
    }

    function submitEdit(){
        if(data.name == ""){
            toast.error("Please enter floor name");
        }else{

            editRoomApi({...data, floor_id:id}, selected).then((res)=>{
                if(res.status == "success"){
                    toast.success("Floor update successfully");
                    getAllRoomApi(id).then((res)=>{
                
                        if(res.status == "success"){
                            
                            setAllRoom(res?.data?.rooms);
                        }
                    })

                    setPop("");
                    setData({name:""});
                    setSelected("");
                }else{
                    toast.error("Failed to add floor");
                }
            })
        }
    }


    function deleteRoom(){
        
        if(confirm("Do you wanted to delete this room?")){
            
        
            deleteRoomApi(selected).then((res)=>{
                
                if(res.status == "success"){
                    toast.success("Room deleted successfully");
                    setPop("");
                    setSelected("");
                    setData({name:""});

                    getAllRoomApi(id).then((res)=>{


                        if(res.status == "success"){
                            setAllRoom(res?.data?.rooms);
                        }
                    })

                }else{
                    toast.error("Failed to delete room");
                }
                
            })

        }
    }




    return(
        <div className=" w-screen h-screen bg-color1">
            <Layout> 
                <div>
                    <h1 className=" py-2 text-2xl text-color4 text-center font-semibold uppercase">Room {id}</h1>
                </div>


                <div className=" w-full h-auto mt-8 pb-4 flex items-center justify-center gap-4 border-b border-color3">
                    <button onClick={()=> (pop == "add")? setPop(""): setPop("add")} className=" bg-color7 text-color1 p-2 rounded-md">Add Room</button>
                    <button onClick={()=> (pop == "edit")? setPop(""): setPop("edit")} className=" bg-color6 text-color1 p-2 rounded-md">Edit Room</button>
                    <button onClick={()=> (pop == "delete")? setPop(""): setPop("delete")} className=" bg-color8 text-color1 p-2 rounded-md">Delete Room</button>
                </div>

                {
                    (pop == "add")&&
                    <div className=" absolute top-60 left-[40%] w-[600px] h-[300px] p-6 bg-color2 rounded-md flex flex-col shadow-cyan-800 shadow-lg ">
                        <h2 className=" mb-12 text-xl text-center text-color4 border-b border-color4"> Add Room</h2>
                        <label htmlFor="name" className=" pb-2 text-lg text-color4">Room Name</label>
                        <input onChange={set} type="text" name="name" id="name" placeholder="Enter Room name:" className=" w-full py-2 px-2 rounded-md bg-color3 border-none outline-none text-color4 text-lg" />
                        <div className=" flex gap-4 mt-8">
                            <button onClick={submitAdd} className=" w-[120px] py-1 rounded-md bg-color7 text-lg">Save</button>
                            <button onClick={()=> setPop("")} className=" w-[120px] py-1 rounded-md bg-color8 text-lg">Cancel</button>
                        </div>
                    </div>
                }

                {
                    (pop == "edit")&&
                    <div className=" absolute top-60 left-[40%] w-[600px] h-[400px] p-6 bg-color2 rounded-md flex flex-col shadow-cyan-800 shadow-lg">
                        <h2 className=" mb-12 text-xl text-center text-color4 border-b border-color4"> Edit Room</h2>

                        <label htmlFor="Room" className=" pb-2 text-lg text-color4">Select Room</label>
                        <select onChange={(e)=> setSelected(e.target.value)} name="Room" id="Room" className=" w-full py-2 px-2 rounded-md bg-color3 border-none outline-none text-color4 text-lg">
                            <option value="">Select Room</option>
                            {
                                allRoom.map((item, index)=>{
                                    return(
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <label htmlFor="name" className=" mt-4 pb-2 text-lg text-color4">Room Name</label>
                        <input onChange={set} type="text" name="name" id="name" placeholder="Enter Room name:" className=" w-full py-2 px-2 rounded-md bg-color3 border-none outline-none text-color4 text-lg" />
                        <div className=" flex gap-4 mt-8">
                            <button onClick={submitEdit} className=" w-[120px] py-1 rounded-md bg-color7 text-lg">Save</button>
                            <button onClick={()=> setPop("")} className=" w-[120px] py-1 rounded-md bg-color8 text-lg">Cancel</button>
                        </div>
                    </div>
                }

                
                {
                    (pop == "delete")&&
                    <div className=" absolute top-60 left-[40%] w-[600px] h-[300px] p-6 bg-color2 rounded-md flex flex-col shadow-cyan-800 shadow-lg ">
                        <h2 className=" mb-12 text-xl text-center text-color4 border-b border-color4"> Delete Room</h2>

                        <label htmlFor="Room" className=" pb-2 text-lg text-color4">Select Room</label>
                        <select onChange={(e)=> setSelected(e.target.value)} name="Room" id="Room" className=" w-full py-2 px-2 rounded-md bg-color3 border-none outline-none text-color4 text-lg">
                            <option value="">Select Room</option>
                            {
                                allRoom.map((item, index)=>{
                                    return(
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <div className=" flex gap-4 mt-8">
                            <button onClick={deleteRoom} className=" w-[120px] py-1 rounded-md bg-color8 text-lg">Delete</button>
                            <button onClick={()=> setPop("")} className=" w-[120px] py-1 rounded-md bg-color7 text-lg">Cancel</button>
                        </div>
                    </div>
                }

                <div>
                    <h2 className=" text-xl text-color4 font-semibold text-center uppercase mt-4">All Rooms</h2>

                    <div className=" w-full h-auto mt-10 flex items-center justify-center gap-6">
                        {
                            allRoom.map((item, index)=>{
                                return(
                                    <Link to={`/live-table/${item.id}`} key={index} className=" w-[160px] h-[120px] bg-color2 text-color4 p-2 rounded-md flex items-center justify-center">
                                        <span className=" text-2xl ">{item.name}</span>
                                    </Link>
                                )
                            })
                        }

                    </div>
                </div>

            </Layout>
        </div>
    )
}


export default RoomDetails;

